import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Subscription} from "../classes/Subscription";

export interface AddPaidByCashSubscriptionRequest {
  subscriptionId: number;
  userId: number;
  startDate?: string;
  paymentMethod: string;
  childId?: number;
  bundleIds?: number[];
}

export interface CreatePaymentLinkRequest {
  userId: number;
  amount: number;
  taxRequired: boolean;
  childId?: number;
}

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'}),
};

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {

  constructor(private httpClient: HttpClient) {
  }

  public getAll(): Observable<Subscription[]> {
    return this.httpClient.get<Subscription[]>(`${environment.backendApiUrl}/v1/subscriptions`, httpOptions);
  }

  public createOrEdit(subscription: Subscription): Observable<void> {
    if (subscription.id) {
      return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/subscriptions/` + subscription.id, subscription, httpOptions);
    }
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/subscriptions`, subscription, httpOptions);
  }

  public delete(id: number, isComplete: boolean = false): Observable<void> {
    const params = isComplete ? '?deleteCompletely=true' : '';
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/subscriptions/` + id + params, httpOptions);
  }

  public addPaidByCashSubscription(data: AddPaidByCashSubscriptionRequest): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/purchased-subscriptions/cash-purchase/`, data, httpOptions);
  }

  public createPaymentLink(data: CreatePaymentLinkRequest): Observable<any> {
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/purchased-subscriptions/create-purchase-link/`, data, httpOptions);
  }

  public deletePurchasedSubscription(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/purchased-subscriptions/` + id, httpOptions);
  }
}
